var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_174419",
    "data-name": "Group 174419",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_3_",
    "data-name": "close (3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21060",
    "data-name": "Path 21060",
    d: "M20,9.05,18.95,8,14,12.95,9.05,8,8,9.05,12.95,14,8,18.95,9.05,20,14,15.05,18.95,20,20,18.95,15.05,14Z",
    transform: "translate(-8 -8)",
    fill: "#203662"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.95f5d6d09f59547d7108d04f3782eead.svg";
export { ForwardRef as ReactComponent };